import React from 'react'
import { useSelector } from 'react-redux'

export default function useClientCards(tempTableId) {
    const clientCards = useSelector((state) => state.gameTable.games[tempTableId].playerCards);

    if (!clientCards || clientCards.length === 0) {
        return []
    }

    return clientCards
}
